'use client'

import * as React from 'react'
import { CheckCircleIcon } from 'primitives/icons'
import * as Tooltip from '@radix-ui/react-tooltip'
import { useTranslations } from 'next-intl'
import { useIsLoggedInQuery } from 'auth/hooks'
import {
  useHasAllAccessQuery,
  useUserIsEligibleForAllAccessFreeTrialQuery,
} from '@repo/cf-user/hooks/use-user-data'
import { tw } from 'utils/classnames'
import { PAYMENT_ENTRY_POINTS } from 'payments/payments-dialog/analytics'
import { StartFreeTrialButton } from 'payments/start-free-trial-button'

export function ProductBoxCheck() {
  const t = useTranslations('prod.product_description_page.discover')
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const { data: isEligibleForAllAccessFreeTrial } = useUserIsEligibleForAllAccessFreeTrialQuery()
  const { data: userHasAllAccess } = useHasAllAccessQuery()

  // Use state to control the tooltip visibility, to support mobile browsers
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false)

  return (
    <Tooltip.Provider>
      <Tooltip.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
        <Tooltip.Trigger
          type="button"
          onClick={() => setIsTooltipOpen(true)}
          className="shrink-0 items-center justify-center p-1"
        >
          <CheckCircleIcon className="text-secondary-500 h-5 w-5" />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            align="start"
            side="bottom"
            sideOffset={5}
            className="text-cf-white bg-secondary-500 w-80 rounded p-3 text-sm lg:flex"
          >
            <div className={tw('text-cf-white rounded-4 max-w-[325px]')}>
              <>
                <div>
                  {userHasAllAccess
                    ? t('access')
                    : isEligibleForAllAccessFreeTrial
                      ? t('try_free')
                      : t('try')}
                </div>
                {userHasAllAccess ? null : (
                  <StartFreeTrialButton
                    entryPoint={PAYMENT_ENTRY_POINTS.MY_ACCOUNT_RECOMMENDATIONS}
                    label={
                      isEligibleForAllAccessFreeTrial || !isLoggedIn
                        ? t('try_free_cta')
                        : t('try_cta')
                    }
                    className="border-cf-white rounded-2 text-cf-white hover:shadow-cf-elevation-light-1 text-12 bg-tra m-0 mt-2 inline-block h-auto border px-4 py-2 font-normal capitalize hover:bg-none"
                  />
                )}
              </>
              <Tooltip.Arrow className="fill-secondary-500" />
            </div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}
